// // MyLottieAnimation.js
import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../../lotties/logo.json'; // замініть на шлях до вашого файлу анімації
import styled from '@emotion/styled';

export const Div= styled.div`
width: 900px;
max-width: 900px;
height: 1400px;
 @media (max-width: 844px) {
  width: 100vw;
  height: 140vw;

  
  } 
`;


const MyLottieAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div style={{ backgroundColor: '#7F56D9', width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Div>
      <Lottie options={defaultOptions} height="100%" width='100%' />
      </Div>
      </div>
  );
};

export default MyLottieAnimation;
